

















































import { Component, Prop, Vue  } from 'vue-property-decorator';
@Component
export default class groupItem extends Vue {
    get goodsDesc(){
      return this.$store.getters["goods/getSpecification"];
    }
    get isActivity(){
        let tag = this.goodsDesc.tagInfo[8200]
        console.log(tag.state);
        
        if(tag.state != 'pre')
            this.getAleradyGroup();
        return tag
    }
    alreadyGroupNum:Number = 0;

    getAleradyGroup(){//团购已团数量
      this.fetch({
          url: `${window.apis.getAleradyGroup}/${this.goodsDesc.tagInfo[8200].activityId}/${this.goodsDesc.listId}/${this._common.getZoneId()}`,
          data: {},
          method:'get'
      }).then((data:any) => {
          this.alreadyGroupNum = data;
      })
    }
}
